DK.skinnyTimer = function (time, id) {
  var second = 1000,
    minute = second * 60,
    hour = minute * 60,
    day = hour * 24;
  setInterval(function () {
    var myDate = new Date();
    var now = myDate.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
    now = new Date(now).getTime();
    distance = time - now;
    if (distance < 0) {
      $(`#promo-container-${id} .skinny-banner-timer`).hide();
      return;
    }
    var days = Math.floor(distance / day).toString(),
      hrs = Math.floor((distance % day) / hour).toString(),
      mins = Math.floor((distance % hour) / minute).toString(),
      rem = Math.floor((distance % minute) / second).toString();

    if (days.length == 1) days = '0' + days;
    if (hrs.length == 1) hrs = '0' + hrs;
    if (mins.length == 1) mins = '0' + mins;
    if (rem.length == 1) rem = '0' + rem;

    $(`.skinny-banner-days-${id}`).text(days);
    $(`.skinny-banner-hours-${id}`).text(hrs);
    $(`.skinny-banner-minutes-${id}`).text(mins);
    $(`.skinny-banner-seconds-${id}`).text(rem);
  }, second);
};
DK.skinnyRotate = function (time, id) {
  var slideCount = $(`#skinny_banner-${id} .skinny-slider .promo-container`).length;
  $(`#skinny_banner-${id}`).width('100vw');
  var marginLeft = slideCount % 2 == 0 ? '100vw' : '0';
  $(`#skinny_banner-${id} .skinny-slider .promo-container`).width('100vw');
  $(`#skinny_banner-${id} .skinny-slider`).css({
    width: '100vw' * slideCount,
    marginLeft: marginLeft,
  });
  if (slideCount > 2) {
    $(`#skinny_banner-${id} .skinny-slider .promo-container:last-child`).prependTo(
      `#skinny_banner-${id} .skinny-slider`
    );
  }

  setInterval(
    function (id) {
      $(`#skinny_banner-${id} .skinny-slider`).animate(
        {
          left: -$(window).width(),
        },
        500,
        function () {
          $(`#skinny_banner-${id} .skinny-slider .promo-container`)
            .first()
            .appendTo(`#skinny_banner-${id} .skinny-slider`);
          $(`#skinny_banner-${id} .skinny-slider`).css('left', '');
        }
      );
    },
    time,
    id
  );
};

